<template>
  <van-form @submit="onSubmit">
    <template v-for="item in formCols" :key="item.prop">
      <!-- text -->
      <van-field
        v-model="formValue[item.prop]"
        :name="item.prop"
        placeholder="请输入"
        :border="false"
        :rules="[{ required: true, message: '请填写' + item.label }]"
        v-if="item.formType === 'text'"
      >
        <template #label>
          <div class="custom-label">{{ item.label }}</div>
        </template>
      </van-field>
      <!-- number -->
      <van-field
        v-model="formValue[item.prop]"
        :name="item.prop"
        placeholder="请输入"
        type="number"
        :border="false"
        :rules="[{ required: true, message: '请填写' + item.label }]"
        v-if="item.formType === 'number'"
      >
        <template #label>
          <div class="custom-label">{{ item.label }}</div>
        </template>
      </van-field>
      <!-- date -->
      <van-field
        v-model="formValue[item.prop]"
        is-link
        readonly
        :name="item.prop"
        placeholder="点击选择日期"
        :border="false"
        :rules="[{ required: true, message: '请选择' + item.label }]"
        v-if="item.formType === 'date'"
        @click="onClickDate(item.prop)"
      >
        <template #label>
          <div class="custom-label">{{ item.label }}</div>
        </template>
      </van-field>
      <!-- radio -->
      <van-field
        :name="item.formProp"
        v-if="item.formType === 'radio'"
        :rules="[{ required: true, message: '请选择' + item.label }]"
        :border="false"
      >
        <template #input>
          <van-radio-group
            v-model="formValue[item.formProp]"
            direction="horizontal"
          >
            <van-radio
              v-for="radio in item.columns"
              :key="radio.dicVal"
              :name="radio.dicVal"
              >{{ radio.dicValMean }}</van-radio
            >
          </van-radio-group>
        </template>
        <template #label>
          <div class="custom-label">{{ item.label }}</div>
        </template>
      </van-field>
    </template>
    <van-popup v-model:show="showPicker" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onConfirmDate"
        @cancel="showPicker = false"
      />
    </van-popup>
    <div style="margin: 16px">
      <van-button
        round
        block
        type="primary"
        native-type="submit"
        @click="type = 1"
      >
        {{ step !== 2 ? '保存并下一步' : '保存' }}
      </van-button>
    </div>
    <div v-if="step === 2" style="margin: 16px">
      <van-button
        round
        block
        type="primary"
        native-type="submit"
        @click="type = 2"
      >
        提交
      </van-button>
    </div>
  </van-form>
</template>

<script setup>
import { Toast, Notify } from 'vant'
import { defineProps, ref, watch, defineEmits } from 'vue'
import { useRouter } from 'vue-router'
import {
  updateCylinderCheckEthyneResult,
  updateCylinderCheckResult
} from '@/api/cylinderManageUserHome'

const router = useRouter()
const formValue = ref({})
const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  },
  formCols: {
    type: Array,
    default: () => []
  },
  step: {
    type: Number,
    required: true
  }
})
/**
 * 初始化formValue
 */
watch(
  () => props.data,
  (val) => {
    formValue.value = val
  },
  {
    immediate: true
  }
)
/**
 * 日期选择
 */
const showPicker = ref(false)
const onConfirmDate = (value) => {
  const date = `${value.getFullYear()}-${
    value.getMonth() + 1
  }-${value.getDate()}`
  formValue.value[dateProp.value] = date
  showPicker.value = false
}
const dateProp = ref('')
const onClickDate = (value) => {
  dateProp.value = value
  showPicker.value = true
}
/**
 * 提交 保存
 */
const emit = defineEmits(['success'])
const type = ref(1)
// 乙炔
const update1 = (value, ctype) => {
  Toast.loading({
    message: '请稍后...',
    forbidClick: true,
    duration: 0
  })
  updateCylinderCheckEthyneResult({
    ctype,
    infoMess: {
      ...props.data,
      ...value
    }
  })
    .then(() => {
      if (type.value === 1) {
        emit('success', value)
      } else {
        router.back()
      }
      Notify({ type: 'success', message: '操作成功' })
    })
    .finally(() => {
      Toast.clear()
    })
}
// 无缝
const update2 = (value, ctype) => {
  Toast.loading({
    message: '请稍后...',
    forbidClick: true,
    duration: 0
  })
  updateCylinderCheckResult({
    ctype,
    infoMess: {
      ...props.data,
      ...value
    }
  })
    .then(() => {
      if (type.value === 1) {
        emit('success', value)
      } else {
        router.back()
      }
      Notify({ type: 'success', message: '操作成功' })
    })
    .finally(() => {
      Toast.clear()
    })
}
const onSubmit = (value) => {
  console.log(type.value)
  if (props.data.cMedium === '1') {
    // 乙炔
    if (props.step === 2) {
      //  type:1保存
      if (type.value === 1) {
        update1(value, '0')
      }
      // type:2提交
      if (type.value === 2) {
        update1(value, '1')
      }
    } else {
      // 保存
      update1(value, '0')
    }
  }
  if (props.data.cMedium === '2') {
    // 无缝
    if (props.step === 2) {
      //  type:1保存
      if (type.value === 1) {
        update2(value, '0')
      }
      // type:2提交
      if (type.value === 2) {
        update2(value, '1')
      }
    } else {
      // 保存
      update2(value, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-cell {
  margin-top: 30px;
  overflow: initial !important;
  .van-field__label {
    width: 0;
    margin: 0;
  }
}
.custom-label {
  position: absolute;
  top: -28px;
}
</style>
